/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 * `pnpm nx run graphql:codegen `
 * for this file to be re-created
 */
import * as Types from '@main/graphql/types.admin.generated';

import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import * as ClientTypes from '@main/graphql/client-scalars';
import { api } from '@main/graphql/shared-api';
export type InsertOrganizationTenantMutationVariables = Types.Exact<{
  orgTenant?: Types.InputMaybe<Types.Organization_Tenants_Insert_Input>;
}>;

export type InsertOrganizationTenantMutation = {
  __typename?: 'mutation_root';
  insert_organization_tenants_one?: { __typename?: 'organization_tenants'; id: string } | null;
};

export type DeleteOrganizationTenantMutationVariables = Types.Exact<{
  name: Types.Scalars['String']['input'];
}>;

export type DeleteOrganizationTenantMutation = {
  __typename?: 'mutation_root';
  delete_organization_tenants?: {
    __typename?: 'organization_tenants_mutation_response';
    affected_rows: number;
  } | null;
};

export const InsertOrganizationTenantDocument = `
    mutation InsertOrganizationTenant($orgTenant: organization_tenants_insert_input = {}) {
  insert_organization_tenants_one(object: $orgTenant) {
    id
  }
}
    ` as string &
  TypedDocumentNode<InsertOrganizationTenantMutation, InsertOrganizationTenantMutationVariables>;
export const DeleteOrganizationTenantDocument = `
    mutation DeleteOrganizationTenant($name: String!) {
  delete_organization_tenants(where: {name: {_eq: $name}}) {
    affected_rows
  }
}
    ` as string &
  TypedDocumentNode<DeleteOrganizationTenantMutation, DeleteOrganizationTenantMutationVariables>;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    InsertOrganizationTenant: build.mutation<
      InsertOrganizationTenantMutation,
      InsertOrganizationTenantMutationVariables | void
    >({
      query: (variables) => ({ document: InsertOrganizationTenantDocument, variables }),
    }),
    DeleteOrganizationTenant: build.mutation<
      DeleteOrganizationTenantMutation,
      DeleteOrganizationTenantMutationVariables
    >({
      query: (variables) => ({ document: DeleteOrganizationTenantDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const { useInsertOrganizationTenantMutation, useDeleteOrganizationTenantMutation } =
  injectedRtkApi;
